// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"5c1386c4fb85bd5fdb7f","453":"ec3546f612143f917ddc"}[chunkId] + ".js";
};